import React, { useState } from 'react';



import VideoCard from '../../../components/VideoCard';



const ContentCard = ({ content, featured = false, onContentClick }) => {
  return (
    <VideoCard
      content={content}
      featured={featured}
      onContentClick={onContentClick}
      variant="default"
      onRatingChange={() => {}}
      onWhatsAppRequest={() => {}}
    />
  );
};

export default ContentCard;